const IOS_UA = 'MELHOR_ENVIO_IOS_WEBVIEW';
const ANDROID_UA = 'MELHOR_ENVIO_ANDROID_WEBVIEW';

export const android = (userAgent) => {
  return userAgent.includes(ANDROID_UA);
}

export const iOS = (userAgent) => {
  return userAgent.includes(IOS_UA);
}

export const webview = (userAgent) => {
  return userAgent.includes(IOS_UA) || userAgent.includes(ANDROID_UA);
}

export function printWebview(jobName = 'Melhor Envio') {
  if ('androidApp' in window) {
    androidApp.printDocument(jobName);
  }

  if (window?.webkit?.messageHandlers?.toggleMessageHandler) {
    window.webkit.messageHandlers.toggleMessageHandler.postMessage({
      message: 'print',
      jobName: jobName,
    });
  }
}
